function UKAddressSelect({ address, city, postcode, onFieldChange }) {
  return (
    <div className="uk-address-manual">
      <div className="form-group">
        <label>Address line *</label>
        <input
          type="text"
          name="address"
          className="form-input"
          value={address}
          onChange={onFieldChange}
          autoComplete="address-line1"
          required
        />
      </div>

      <div className="form-group">
        <label>Town / City *</label>
        <input
          type="text"
          name="city"
          className="form-input"
          value={city}
          onChange={onFieldChange}
          autoComplete="address-level2"
          required
        />
      </div>

      <div className="form-group">
        <label>Postcode *</label>
        <input
          type="text"
          name="postcode"
          className="form-input"
          value={postcode}
          onChange={onFieldChange}
          autoComplete="postal-code"
          required
        />
      </div>

      <p className="form-helper-text">
        Shipping is available within the United Kingdom. Please double-check your address before
        continuing.
      </p>
    </div>
  );
}

export default UKAddressSelect;

